module.exports = __webpack_public_path__ + "img/Transport_new_stock.38d1f866.svg";